<template>
  <div class="audit-table">
    <a-table
      v-if="!loading"
      :columns="columns"
      :data-source="newList"
      :pagination="false"
      row-key="inquiryid"
      @change="handleTableChange"
    >
      <span
        slot="code"
        slot-scope="text, record, index"
        class="code btn"
        @click="handlerDetail(text, record, index)"
      >{{ text.code }}</span>
      <span
        slot="contact_info_company_name"
        slot-scope="text"
        class="company"
      >
        <company-tooltip :text="text" />
      </span>
      <span
        slot="contact_info"
        slot-scope="text"
        class="contact_detail"
      >
        <contact-tooltip :text="text" />
      </span>
      <template
        slot="input_time"
        slot-scope="text"
      >
        <p
          v-if="text === '- -'"
          class="empty-time"
        >
          {{ text }}
        </p>
        <div
          v-else
          class="input_time"
        >
          <p class="date">
            {{ text && text.split(' ') && text.split(' ')[0] }}
          </p>
          <p class="time fs-gray">
            {{ text && text.split(' ') && text.split(' ')[1] }}
          </p>
        </div>
      </template>
      <a
        slot="action"
        slot-scope="text, record, index"
        href="javascript:;"
        class="detail-btn btn-text"
        @click="handlerDetail(text, record, index)"
      >{{ $t('message["1316"]') }}</a>
    </a-table>
    <a-spin
      v-else
      class="spin-fixed-center"
    />
    <pagination
      v-if="newList && newList.length"
      ref="pagination"
      :pagination="pagination"
      @change="handlePage"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import Pagination from '@/components/pc/Pagination'
import ContactTooltip from './../tooltip/ContactTooltip'
import CompanyTooltip from './../tooltip/CompanyTooptip'
import moment from 'moment'
import { getEncode } from '@/lib/mix'
import { setCodeData } from '@/lib/utils'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    Pagination,
    ContactTooltip,
    CompanyTooltip
  },
  props: {
    status: {
      type: [String, Number],
      default: () => { }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('inquery/auditData', [
      'loading',
      'list',
      'pagination',
      'tableSort'
    ]),
    ...mapGetters('inquery/auditData', [
      'columns',
      'newList'
    ]),
    pid () {
      return this.$route.params.pid
    },
    type () {
      return this.$route.query.type
    },
    _type () {
      return this.type === 'wait-audit' ? 0 : this.type === 'refused-audit' ? -1 : ''
    },
    keywordsStr () {
      return this.$route.query.keywords
    },
    keywords () {
      let keywords = {}
      if (this.keywordsStr) {
        keywords = JSON.parse(decodeURIComponent(this.keywordsStr))
      }
      return keywords
    },
    currentPage () {
      const { page = 1 } = this.$route.query
      return parseInt(page)
    },
    pageSize () {
      const { limit = 10 } = this.$route.query
      return parseInt(limit)
    }
  },
  watch: {
    type (val) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = 10

      // this.getAuditList()
    },
    $route (to, from) {
      this.pagination.currentPage = this.currentPage
      this.pagination.pageSize = this.pageSize

      this.getAuditList()
    }
  },

  async created () {
    this.pagination.currentPage = this.currentPage
    this.pagination.pageSize = this.pageSize

    this.getAuditList()
    eventBus.$on('fetchAuditList', this.getAuditList)
  },
  beforeDestroy () {
    eventBus.$off('fetchAuditList', this.getAuditList)
  },

  methods: {
    moment,
    ...mapMutations('inquery/auditData', ['UPDATA_ORDER', 'SET_TABLE_SORT']),
    ...mapActions('inquery/auditData', ['fetchList']),
    async getAuditList (obj) {
      let params = {}
      let tableSort = this.tableSort

      if (this.keywordsStr) {
        const enCode = await getEncode()

        if (!/^L?\d+$/.test(this.keywords.keyword1)) {
          this.keywords.keyword1 = await setCodeData(this.keywords.keyword1, enCode)
        }
        this.keywords.keyword2 = await setCodeData(this.keywords.keyword2, enCode)
        this.keywords.keyword3 = await setCodeData(this.keywords.keyword3, enCode)
      }

      'sortkey' in tableSort && Object.assign(params, { sortkey: tableSort.sortkey })
      'sorttype' in tableSort && Object.assign(params, { sorttype: tableSort.sorttype })
      'sortfieldtype' in tableSort && Object.assign(params, { sortfieldtype: tableSort.sortfieldtype })

      const chain = await this.fetchList()
      chain
        .params({
          ...this.keywords,
          type: this._type,
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          ...params,
          ...obj
        })
        .onSuccess(res => {
          document.title = this.$t('message["1048"]') + ' - ' + this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
        })
        .fetch()
    },
    handleTableChange (pagination, filters, sorter) {
      if (sorter.order) {
        let sort = 0
        if (sorter.order === 'ascend') {
          sort = 1 // 正序
        } else if (sorter.order === 'descend') {
          sort = 2 // 倒序
        } else {
          sort = 0
        }

        let order = sort === 1 ? 'ascend' : 'descend'
        this.UPDATA_ORDER(order)
        // console.log(sort)
        let tableSort = {
          sortkey: sorter.column.sortkey,
          sorttype: sort,
          sortfieldtype: sorter.column.fieldtype
        }
        this.SET_TABLE_SORT({ tableSort, sorter })

        this.$router.push({
          query: {
            ...this.$route.query,
            // ...tableSort,
            page: pagination.currentPage,
            limit: pagination.pageSize,
            _t: new Date().getTime()
          }
        })

        this.getAuditList()
      } else {
        /* let tableSort = {
          sortkey: '',
          sorttype: 0,
          sortfieldtype: ''
        } */
        this.SET_TABLE_SORT({ tableSort: {}, sorter: {} })
        this.$router.push({
          query: {
            ...this.$route.query,
            // ...tableSort,
            page: pagination.currentPage,
            limit: pagination.pageSize,
            _t: new Date().getTime()
          }
        })
      }
    },
    handlePage (pagination) {
      this.pagination.currentPage = pagination.currentPage
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagination.currentPage,
          limit: pagination.pageSize
        }
      })
      this.getAuditList()
    },
    handlerDetail (text, record, index) {
      this.$router.push({
        path: `/project/${this.pid}/inquery/detail/${record.inquiryid}`,
        query: {
          ...this.$route.query,
          from: 'audit'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-table-wrapper {
  padding-top: 24px;
}
/* td 内的内容 hover 时加底 */
.company > span,
.contact_detail > span {
  padding: 3px 7px;
  border: solid 1px rgba(0, 0, 0, 0);
  border-radius: 4px;
}
.input_time {
  font-size: 12px;
  position: absolute;
  top: 8px;
  line-height: 16px;
}
</style>
<style lang="scss">
.audit-table {
  .ant-table-body {
    width: 100%;
    table {
      table-layout: fixed;
      width: 100%;
    }
  }
}
/* ant-tooltip 联系人弹层样式修改 */
.contact-tooltip {
  width: 240px;
  .ant-tooltip-inner {
    padding: 16px;
    overflow: auto;
  }
  .name,
  label,
  .mobiles {
    margin-bottom: 16px;
  }
  .mobiles > p,
  .emails > p {
    color: $gray2;
  }
}
</style>
